import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
  keywords?: string;
}

function upsertMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    if (description) {
      upsertMeta("description", description);
      upsertMeta("og:description", description, "property");
    }
    if (keywords) {
      upsertMeta("keywords", keywords);
    }
    upsertMeta("og:title", title, "property");
  }, [title, description, keywords]);
}

export default usePageMeta;